import { useState, useContext, createContext, ReactNode, Dispatch, SetStateAction } from 'react';
import type { StyledParagraphState } from 'slate/extensions/styled-paragraph/components/StyledParagraphElement';

export interface SidebarComment {
  id?: string;
  [key: string]: unknown;
}

export interface SidebarContextValue {
  draftComment: SidebarComment | null;
  setDraftComment: Dispatch<SetStateAction<SidebarComment | null>>;
  styledParagraph: StyledParagraphState | null;
  setStyledParagraph: Dispatch<SetStateAction<StyledParagraphState | null>>;
  isSidebarOpen: number;
  setIsSidebarOpen: Dispatch<SetStateAction<number>>;
  activeComment: SidebarComment | null;
  setActiveComment: Dispatch<SetStateAction<SidebarComment | null>>;
  activeTagsTab: string;
  setActiveTagsTab: (value: string) => void;
}

export const SidebarContext = createContext<SidebarContextValue>({} as SidebarContextValue);

export const useSidebar = (): SidebarContextValue => useContext(SidebarContext);

export const SidebarContextProvider = ({ children }: { children: ReactNode }) => {
  const [styledParagraph, setStyledParagraph] = useState<StyledParagraphState | null>(null);
  const [draftComment, setDraftComment] = useState<SidebarComment | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState<number>(0);
  const [activeComment, setActiveComment] = useState<SidebarComment | null>(null);
  const [activeTagsTab, setActiveTagsTab] = useState<string>('taxonomy'); // 'taxonomy' | 'allTags' | 'tagInfo'

  return (
    <SidebarContext.Provider
      value={{
        draftComment,
        setDraftComment,
        styledParagraph,
        setStyledParagraph,
        isSidebarOpen,
        setIsSidebarOpen,
        activeComment,
        setActiveComment,
        activeTagsTab,
        setActiveTagsTab,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
